<template>
    <div :class="fontSize == 2 ? 'bottomText' : fontSize == 1 ? 'bottomText titleSmall' : 'bottomText titleBig'" style="    text-align: center;
    color: gray;
    padding: 20px;">-- 已加载到底部 --</div>
</template>
<script>
import store from '@/store';
import { onMounted, watch, ref } from 'vue';
export default {
    name: 'Bottom',
    setup() {
        watch(() => store.getters.fontSize, (val) => {
            fontSize.value = val
        })
        onMounted(() => {
            fontSize.value = store.getters.fontSize
        })
        const fontSize = ref('')
        return {
            fontSize
        }
    }
}
</script>
<style scoped>
.bottomText.titleSmall {
    font-size: 12px;
}

.bottomText.titleBig {
    font-size: 16px;
}
</style>